// Normalize an `image` meta value into props for an <img> tag.
// Accepts:
//   - string: '/path/to/file.jpg'
//   - object: { src, srcSet, sizes } — browser picks the best size
//   - null/undefined: returns { src: fallback }
export function imageProps(image, fallback) {
  if (!image) return { src: fallback };
  if (typeof image === 'string') return { src: image };
  return {
    src: image.src || fallback,
    srcSet: image.srcSet,
    sizes: image.sizes
  };
}
